import BaseStore from '@src/utils/store/base-store';
import DropDownMenuStore from './dropDownMenu/store';
import { observable, computed } from 'mobx';
import { jumpPage } from '@src/utils/common-util';
import { autobind } from 'core-decorators';
import SelectStore from '@src/business-components/common-language-select/store';
import copy from '@src/components/copy';
import BGMStore from '@src/business-components/bgm/store';
import { getLocales } from '@src/global-locales/get-page-locales-data';
import FollowUsStore from '@src/business-components/common-follow-us/store';
import { $$tracker } from '@src/tracker';
import message from '@src/components/common-message';
import useModal from '@src/utils/hooks/use-modal';
import AppointmentModal from '@src/business-components/appointment-modal';
import AppointmentModalStore from '@src/business-components/appointment-modal/store';
import AppointmentSuccessModal from '@src/business-components/appointment-success-modal';
import AppointmentSuccessModalStore from '@src/business-components/appointment-success-modal/store';
import getLanguageByPath from '@src/utils/locale/getLanguageByPath';

const lang = getLanguageByPath();

export const NAVTYPE = {
  ANCHOR: 'anchor',
  Link: 'link',
  SELECT: 'select'
};

const linkMap = {
  '': 'index'
};

// 客服中心链接
const callCenterLinkMap = {
  en: 'https://gm-mobile.amazingseasun.com/app/h5/jxj/en-US/index',
  ja: 'https://gm-mobile.amazingseasun.com/app/h5/jxj/ja-JP/index',
  ko: 'https://gm-mobile.amazingseasun.com/app/h5/jxj/ko-KR/index',
  'zh-Hant': 'https://gm-mobile.amazingseasun.com/app/h5/jxj/zh-TW/index',
  es: 'https://gm-mobile.amazingseasun.com/app/h5/jxj/es-ES/index',
  pt: 'https://gm-mobile.amazingseasun.com/app/h5/jxj/pt-PT/index',
  de: 'https://gm-mobile.amazingseasun.com/app/h5/jxj/de-DE/index',
  fr: 'https://gm-mobile.amazingseasun.com/app/h5/jxj/fr-FR/index',
  ru: 'https://gm-mobile.amazingseasun.com/app/h5/jxj/ru-RU/index',
  th: 'https://gm-mobile.amazingseasun.com/app/h5/jxj/th-TH/index'
};

// 先驱小队活动链接
const pioneerTeamActivityLinkMap = {
  en: '//mechabreak.seasungames.com/index/en/index.html#/',
  ja: '//mechabreak.seasungames.com/index/ja/index.html#/',
  ko: '//mechabreak.seasungames.com/index/ko/index.html#/',
  'zh-Hant': '//mechabreak.seasungames.com/index/zh-Hant/index.html#/'
};

class NaviBarStore extends BaseStore {
  selectStore = new SelectStore();
  /**
   * 关注我的store
   * @type {FollowUsStore}
   */
  followUsStore = new FollowUsStore();
  // @observable
  // bgm = new BGMStore({
  //   audioSrc: 'https://static-www.mechabreak.com/MP4/20231204/20231122bgm.mp3',
  //   musicPlayIcon: require('./images/music-on.png'),
  //   musicPauseIcon: require('./images/music-off.png'),
  //   musicIconRotate: false
  // });
  @computed
  get bgm() {
    return this.$globalStore.bgm;
  }

  /**
   * 登录展开
   * @type {boolean}
   */
  @observable loginExpand = false;

  @observable isSticky = false;

  @observable
  navList = [
    {
      type: NAVTYPE.Link,
      anchor: '#root',
      link: '',
      title: getLocales('navbar.home'),
      tracker: () => {
        $$tracker.clickMainNaviBarHome();
      }
    },
    {
      type: NAVTYPE.Link,
      link: 'news-list',
      title: getLocales('navbar.news'),
      tracker: () => {
        $$tracker.clickMainNaviBarNews();
      }
    },
    {
      type: NAVTYPE.SELECT,
      title: getLocales('navbar.games_introduction'),
      childs: [
        {
          title: getLocales('navbar.game_play'),
          link: 'game-play',
          tracker: () => {
            $$tracker.clickMainNaviBarCombat();
          }
        },
        {
          title: getLocales('navbar.mecha'),
          link: 'mecha-list',
          tracker: () => {
            $$tracker.clickMainNaviBarStrikers();
          }
        },
        {
          title: getLocales('navbar.map'),
          link: 'map',
          tracker: () => {
            $$tracker.clickMainNaviBarMaps();
          }
        },
        {
          title: getLocales('navbar.map3v3'),
          link: 'map-wpxl',
          tracker: () => {
            $$tracker.clickMainNaviBarMaps();
          }
        },
        {
          title: getLocales('navbar.world_view'),
          link: 'world-view',
          tracker: () => {
            $$tracker.clickMainNaviBarWorld();
          }
        },
        // {
        //   title: getLocales('navbar.listOfAppearances'),
        //   isHref: true,
        //   link: '//mechabreak.seasungames.com/index/en/index.html#/'
        // },
        {
          title: getLocales('navbar.msmk_raiders'),
          isHref: true,
          link: '//mechabreak.seasungames.com/index/en/index.html#/',
          toast: getLocales('global.comming_soon')
        }
      ]
    },
    {
      type: NAVTYPE.SELECT,
      title: getLocales('navbar.FAQ'),
      childs: [
        {
          title: getLocales('navbar.callCenter'),
          isHref: true,
          link: callCenterLinkMap[lang]
        }
      ]
    }
    // {
    //   type: NAVTYPE.SELECT,
    //   title: getLocales('navbar.activity_zone'),
    //   childs: [
    //     {
    //       title: getLocales('navbar.creator_progam'),
    //       link: '//mechabreak.seasungames.com/index/en/index.html#/',
    //       isHref: true,
    //       tracker: () => {
    //         $$tracker.clickMainNaviBarCR();
    //       }
    //     },
    //     {
    //       title: getLocales('navbar.pioneerTeamActivity'),
    //       link: '//mechabreak.seasungames.com/index/en/index.html#/',
    //       tracker: () => {},
    //       onClick: () => {
    //         copy(pioneerTeamActivityLinkMap[lang] || pioneerTeamActivityLinkMap['em'], {
    //           autoDisplaySupportedAlert: false
    //         });
    //         message.info(getLocales('global.copiedGoToMobileToOpen'));
    //       }
    //     },
    //     {
    //       title: getLocales('navbar.twitch_drop'),
    //       link: '//mechabreak.seasungames.com/index/en/index.html#/',
    //       isHref: true,
    //       tracker: () => {
    //         $$tracker.clickMainNaviBarTD();
    //       }
    //     }
    //   ]
    // },
    // {
    //   type: NAVTYPE.SELECT,
    //   title: getLocales('navbar.pack_center'),
    //   childs: [
    //     {
    //       title: getLocales('navbar.collectors_pack'),
    //       link: IS_DEV_ENV
    //         ? 'https://test-zt.xoyo.games/mechabreak.seasungames.com/p/zt/2025/03/21/market/en/index.html#/'
    //         : 'https://mechabreak.seasungames.cn/#/',
    //       isHref: true,
    //       tracker: () => {
    //         $$tracker.clickMainNaviBarCB();
    //       }
    //     }
    //   ]
    // }
  ];

  /**
   * 跳转页面
   * @param link 路由链接
   * @param isHref 是否为外链
   */

  toPage = (link, isHref, toast) => {
    if (toast) {
      message.info(toast);
      return;
    }

    const htmlLink = linkMap[link] || link;
    if (isHref) {
      window.open(link);
    } else if (!IS_DEV_ENV) {
      const url = `${htmlLink}.html`;
      jumpPage(url, '#/');
    } else {
      this?.redirect('/' + link);
    }
  };

  dropDownMenuStore = new DropDownMenuStore();

  @autobind
  onCopyLink() {
    copy(window.location.href);
  }

  @autobind
  onLoginContainerIn() {
    this.loginExpand = true;
  }

  @autobind
  onLoginContainerLeave() {
    this.loginExpand = false;
  }

  // 登录
  login = () => {
    const { isDownloadStage } = this.$globalStore;
    if (isDownloadStage) {
      super.login();
    } else {
      this.appointment.open();
    }
  };

  // 退出登录
  exitAccount = async () => {
    const { authServise } = this.$globalStore;
    await this.$ztService.logout();
    this.$globalStore.accountInfo = null;
    authServise.exitAccount();
  };

  // 预约弹窗
  appointment = null;
  appointmentModalStore = new AppointmentModalStore({
    $main: this,
    appointmentSuccessCallBack: email => {
      this.appointmentSuccessModalStore.email = email;
    }
  });

  // 预约成功弹窗
  appointmentSuccessModal = null;
  appointmentSuccessModalStore = new AppointmentSuccessModalStore({ $main: this });

  @autobind
  toDownloadPage() {
    this.toPage('download', false);
  }

  use() {
    super.use();

    this.appointment = useModal(AppointmentModal, { store: this.appointmentModalStore });
    this.appointmentSuccessModal = useModal(AppointmentSuccessModal, { store: this.appointmentSuccessModalStore });
  }
}

export default NaviBarStore;
